(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
 $('.gallery-pop').magnificPopup({
      type: 'image',
      closeOnContentClick: true,
      mainClass: 'mfp-img-mobile',
      image: {
        verticalFit: true
      }

    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-vertical-mega-menu"]) return;
  try {
    
$("#init-toggle").click(function(){
    $(this).toggleClass('open');
    $(".vertical-mega-menu").toggleClass('open');    
  });

  jQuery(document).ready(function($) {  
   "use strict";    
     
       if($(window).width() <= 991) { 
      
      $("nav.vertical-mega-menu").each(function() {
  
        var vdata = $(this).data('vmenu'),                    
            ulData = $(this).find('ul[data-vmenu="' + vdata + '"]').clone().removeClass('dt-vnav'),
            vmobileData = $('body').find('.mobile-vmenu[data-vmenu="' + vdata + '"]');        

        console.log(ulData);
        // To Remove animation classes
        $('[data-animation]', ulData).each(function(ix, ele) {
          var $classes = $(ele).attr("class"),
              $animation = $(ele).attr("data-animation");
          $classes = $classes.replace($animation, '');
          $(ele).attr("class", $classes);
        });  
        ulData.prependTo(vmobileData);
      });
  
      VmobileTrigger();
  
      // Closing Mobile Nav
      $('li.v-close-nav').on('click', function(event) {
        VcloseMobNav();
      });
  
      $('body .vertical-mobile-menu-overlay').on('click', function(event) {
        VcloseMobNav();
      });
  
      // Sub Menu in Mobile Menu
      $('.from-vertical.menu-item-has-children > a.vMenu').on('click', function(event) {
  console.log('clciked');
        if ($('body').hasClass('vnav-is-visible')) {
          event.preventDefault();
          var a = $(this).clone();
          $(this).next('.v-menu-sub').find('.see-all').html(a);          
        }
  
        var selected = $(this);                
        if (selected.next('div.v-menu-sub').hasClass('is-v-hidden')) {          
          console.log("selected="+selected);
          selected.addClass('selected').next('div.v-menu-sub').removeClass('is-v-hidden');
        } else {          
          selected.removeClass('selected').next('div.v-menu-sub').addClass('is-v-hidden');
        }
      });
  
      // Go Back in Mobile Menu
      $('.go-back').on('click', function() {
        //$(this).parent('div.v-menu-sub').addClass('is-v-hidden');
        $(this).closest('div.v-menu-sub').addClass('is-v-hidden');
      });
    }
  

   function VmobileTrigger(){
      $('.vmenu-trigger').on('click', function(event) {    
        $('body').find('.mobile-vmenu').addClass('vnav-is-visible');
        $('body').find('.mobile-menu-overlay').addClass('is-showit');
        $('body').addClass('vnav-is-visible');        
      });  
    }
  
    function VcloseMobNav() {
      $('body').removeClass('vnav-is-visible');
      $('.vertical-mobile-menu-overlay').removeClass('is-showit');
      $('.mobile-vmenu').removeClass('vnav-is-visible');
      $('.menu-item-has-children a').removeClass('selected');
      $('.menu-item-has-children div.v-menu-sub').addClass('is-v-hidden');
    }
  
    $(window).on('resize',function() {
      VmobileTrigger();
      VcloseMobNav();          
    });
  
    $(window).on('load',function() {     
      VmobileTrigger();
      VcloseMobNav();  
    });
});
  


  
  $('.level-has-child li.leavel-has-dropdown').click(function () {  
          $('li.leavel-has-dropdown').not(this).find('ul').hide();  
          $(this).find('ul').toggle();  
      });  

  } catch(e) { console.error(e); }
})();
})();
